import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Service from "../../config/networkutils";
import React, { Component } from 'react'
import { withSnackbar } from 'notistack';
import { getCookie } from '../../utils/CookieHelper';
import { Box, Button, Chip, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Tooltip, IconButton, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Select, MenuItem, InputAdornment, Checkbox, ListItemText, ListSubheader } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import CommentIcon from '@material-ui/icons/Comment';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import FilterListIcon from '@material-ui/icons/FilterList';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import XLSX from 'xlsx';
import { getPrimaryColor } from '../Helper/CommonThings';
import { CoffeeLoading } from 'react-loadingg';
import PostAddIcon from '@material-ui/icons/PostAdd';
import GetAppIcon from '@material-ui/icons/GetApp';

const token = getCookie("ptd_ts_token");

const dialogPaperStyle = {
    borderRadius: 8,
    overflow: 'hidden'
};

const dialogTitleStyle = {
    backgroundColor: '#f5f8fb',
    borderBottom: '1px solid #dfe7ef',
    padding: '14px 24px'
};

const dialogContentStyle = {
    paddingTop: 18,
    paddingBottom: 8,
    backgroundColor: '#ffffff'
};

const dialogActionsStyle = {
    borderTop: '1px solid #edf1f5',
    padding: '12px 24px',
    backgroundColor: '#fbfcfd'
};

const compactTableCellStyle = {
    padding: '4px 9px',
    fontSize: 12,
    whiteSpace: 'nowrap'
};

const compactFilterCellStyle = {
    ...compactTableCellStyle,
    padding: '2px 9px'
};

const atrStatusOptions = [
    { id: 0, name: 'Pending' },
    { id: 1, name: 'Live' },
    { id: 2, name: 'Rejected' },
    { id: 3, name: 'Hold' },
    { id: 4, name: 'Completed' },
];

const completedAtrStatusId = 4;
const atrFormStatusOptions = atrStatusOptions.filter((option) => option.id !== completedAtrStatusId);

const liveCandidateStatusId = 0;
const excludedAtrPayloadFields = [];

class Atr extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: true,
            tableLoading: false,
            addDialogOpen: false,
            addDialogMode: 'add',
            selectedRow: null,
            addingRowData: {},
            lookupData: {
                market_subvertical: [],
                region: [],
                payrole_process: []
            },
            crmData: [],
            columns: [
                { title: 'BBUK Number', field: 'bbuk_number' },
                { title: 'Status', field: 'status', lookup: atrStatusOptions.reduce((lookup, option) => ({ ...lookup, [option.id]: option.name }), {}) },
                { title: 'Division', field: 'division_name' },
                { title: 'Region', field: 'owner_region_name' },
                { title: 'Discipline', field: 'discipline_name' },
                { title: 'CRM', field: 'crm_name' },
                { title: 'Role Group', field: 'role_groups', displayOnly: true },
                { title: 'Role', field: 'role_name' },
                { title: 'Payrole Process', field: 'payrole_process_name' },
                { title: 'Owner', field: 'owner' },
                { title: 'Last Candidate', field: 'last_candidate' },
                { title: 'Date Opened', field: 'date_opened' },
                { title: 'Last Comment', field: 'last_comment' },
            ],
            selectedData: {},
            buttonDisabled: false,
            addCandidateDialogOpen: false,
            addCandidateData: {},
            candidateListDialogOpen: false,
            candidateList: [],
            isEdit: false,
            searchQuery: '',
            filters: {},
            dropdownFilterSearches: {},
            columnFilterField: null,
            columnFilterValue: ''
        }
    }

    getRowId(row, index) {
        return row?.id || row?.pk || row?.bbuk_number || row?.owner || index;
    }

    getPayload(row) {
        return this.state.columns.reduce((payload, column) => {
            if (column.displayOnly) {
                return payload;
            }
            payload[column.field] = row?.[column.field] ?? '';
            return payload;
        }, {});
    }

    getApiErrorMessage(error) {
        if (error?.data?.message) {
            return error.data.message;
        }
        if (error?.data?.detail) {
            return error.data.detail;
        }
        return 'Something went wrong!';
    }

    isRequiredValueEmpty(value) {
        if (value === null || value === undefined) {
            return true;
        }
        if (typeof value === 'string') {
            return value.trim() === '';
        }
        if (typeof value === 'object') {
            return Object.keys(value).length === 0;
        }
        return false;
    }

    getFirstAvailablePayloadValue(payload, fields) {
        return fields.map((field) => payload[field]).find((value) => !this.isRequiredValueEmpty(value));
    }

    validatePayload(payload) {
        const requiredFields = [
            { label: 'Owner', fields: ['owner'] },
            { label: 'BBUK Number', fields: ['bbuk_number'] },
            { label: 'Division', fields: ['division'] },
            { label: 'Region', fields: ['region', 'owner_region'] },
            { label: 'Payrole Process', fields: ['payrole_process'] },
            { label: 'Role', fields: ['role'] },
            { label: 'Discipline', fields: ['discipline'] },
            { label: 'Status', fields: ['status'] },
            { label: 'Date Opened', fields: ['date_opened'] },
        ];
        const missingFields = requiredFields
            .filter((field) => this.isRequiredValueEmpty(this.getFirstAvailablePayloadValue(payload, field.fields)))
            .map((field) => field.label);

        if (missingFields.length > 0) {
            this.props.enqueueSnackbar(`${missingFields.join(', ')} ${missingFields.length === 1 ? 'is' : 'are'} required.`, {
                variant: 'warning'
            });
            return false;
        }
        if (!this.isValidDateValue(payload.date_opened)) {
            this.props.enqueueSnackbar('Date Opened must be a valid date.', {
                variant: 'warning'
            });
            return false;
        }
        return true;
    }

    normalizeFieldValue(value) {
        if (value === null || value === undefined) {
            return '';
        }
        if (typeof value === 'object') {
            if (value.id !== undefined && value.id !== null) {
                return value.id;
            }
            if (value.value !== undefined && value.value !== null) {
                return value.value;
            }
            if (value.label !== undefined && value.label !== null) {
                return value.label;
            }
        }
        return value;
    }

    getMomentDate(value) {
        if (value === null || value === undefined || value === '') {
            return null;
        }

        if (value instanceof Date) {
            const date = moment(value);
            return date.isValid() ? date : null;
        }

        const date = moment(value, ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD/MM/YYYY', moment.ISO_8601], true);
        return date.isValid() ? date : null;
    }

    isValidDateValue(value) {
        return Boolean(this.getMomentDate(value));
    }

    formatDateToYMD(value) {
        const date = this.getMomentDate(value);
        if (!date) {
            return '';
        }

        return date.format('YYYY-MM-DD');
    }

    formatDateToDMY(value) {
        const date = this.getMomentDate(value);
        if (!date) {
            return '';
        }

        return date.format('DD-MM-YYYY');
    }

    getDatePickerValue(value) {
        const date = this.getMomentDate(value);
        return date ? date.toDate() : null;
    }

    getRoleGroupNames(value) {
        const roleGroups = Array.isArray(value) ? value : value ? [value] : [];
        return roleGroups
            .map((roleGroup) => typeof roleGroup === 'object'
                ? roleGroup.name || roleGroup.label || roleGroup.value || roleGroup.role_group || roleGroup.id
                : roleGroup)
            .filter((roleGroup) => roleGroup !== null && roleGroup !== undefined && String(roleGroup).trim() !== '')
            .map((roleGroup) => String(roleGroup));
    }

    getAddPayload() {
        const mergedData = {
            ...this.state.addingRowData,
            ...this.getPayload(this.state.addingRowData)
        };

        return Object.keys(mergedData).reduce((payload, key) => {
            if (key === 'updated_by' || excludedAtrPayloadFields.includes(key)) {
                return payload;
            }
            const normalizedValue = this.normalizeFieldValue(mergedData[key]);
            payload[key] = key.toLowerCase().includes('date') ? this.formatDateToYMD(normalizedValue) : normalizedValue;
            return payload;
        }, {});
    }

    getAutocompleteValue(field, options = []) {
        const fieldAliases = {
            region: ['owner_region', 'owner_region_name']
        };
        const values = [field, ...(fieldAliases[field] || [])]
            .map((key) => this.state.addingRowData[key])
            .filter((value) => value !== null && value !== undefined && value !== '');
        const value = values[0];

        if (!value) {
            return null;
        }
        if (typeof value === 'object') {
            return options.find((option) => String(option?.id) === String(value.id)) || value;
        }

        const rawValue = String(value).trim().toLowerCase();
        return options.find((option) => (
            String(option?.id) === String(value)
            || String(option?.name || '').trim().toLowerCase() === rawValue
            || String(option?.label || '').trim().toLowerCase() === rawValue
        )) || null;
    }

    getLookupConfig(field) {
        const lookupData = this.state.lookupData || {};
        const configs = {
            division_name: { valueField: 'division', options: lookupData.market_subvertical || [] },
            discipline_name: { valueField: 'discipline', options: lookupData.subsector || [] },
            payrole_process_name: { valueField: 'payrole_process', options: lookupData.payrole_process || [] },
            crm_name: { valueField: 'crm', options: lookupData.crm || this.state.crmData || [] },
            owner_region_name: { valueField: 'owner_region', options: lookupData.owner_region_sector || [] },
            role_name: { valueField: 'role', options: lookupData.job_title || [] },
            role_groups: { valueField: 'role_groups', options: lookupData.role_group || [] },
        };

        return configs[field] || null;
    }

    getLookupOptionLabel(option) {
        if (option === null || option === undefined) {
            return '';
        }
        if (typeof option === 'object') {
            return option.name || option.label || option.value || option.id || '';
        }
        return option;
    }

    getLookupDisplayValue(row, column) {
        const fieldValue = row?.[column.field];
        const isEmptyCrmValue = (value) => value === null || value === undefined || String(value).trim().toLowerCase() === 'null' || String(value).trim().toLowerCase() === 'undefined';

        if (column.field === 'role_groups') {
            return this.getRoleGroupNames(fieldValue).join(', ');
        }

        if (column.field === 'date_opened') {
            return this.formatDateToDMY(fieldValue);
        }

        if (column.lookup) {
            const lookupKey = typeof fieldValue === 'object' ? fieldValue?.id : fieldValue;
            return column.lookup[lookupKey] || this.getLookupOptionLabel(fieldValue);
        }

        const lookupConfig = this.getLookupConfig(column.field);
        if (!lookupConfig) {
            return fieldValue;
        }

        if (column.field === 'crm_name' && isEmptyCrmValue(fieldValue) && isEmptyCrmValue(row?.[lookupConfig.valueField])) {
            return '';
        }

        const displayValue = this.getLookupOptionLabel(fieldValue);
        if (displayValue) {
            return displayValue;
        }

        const rawValue = row?.[lookupConfig.valueField];
        const lookupValue = typeof rawValue === 'object' ? rawValue?.id || rawValue?.value || rawValue?.name || rawValue?.label : rawValue;
        const selectedOption = lookupConfig.options.find((option) => (
            String(option?.id) === String(lookupValue)
            || String(option?.name || '').trim().toLowerCase() === String(lookupValue || '').trim().toLowerCase()
            || String(option?.label || '').trim().toLowerCase() === String(lookupValue || '').trim().toLowerCase()
        ));

        return this.getLookupOptionLabel(selectedOption) || this.getLookupOptionLabel(rawValue);
    }

    getTableCellText(row, column) {
        return this.getSearchableText(this.getLookupDisplayValue(row, column));
    }

    isCompletedAtrStatus(status) {
        if (status === null || status === undefined || status === '') {
            return false;
        }
        if (typeof status === 'object') {
            return String(status.id) === String(completedAtrStatusId)
                || String(status.name || status.label || '').trim().toLowerCase() === 'completed';
        }
        return String(status) === String(completedAtrStatusId)
            || String(status).trim().toLowerCase() === 'completed';
    }

    getData() {
        this.setState({ tableLoading: true })
        let url = '/api/atr/records/get_atr_records/';
        if (this.props.status === 'completed') {
            url += '?completed=true';
        }
        Service.get(url, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    data: res.data,
                    isLoading: false,
                    tableLoading: false
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({ isLoading: false, tableLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    handleOpenEditDialog = (row) => {
        if (this.isCompletedAtrStatus(row?.status)) {
            this.props.enqueueSnackbar('Completed ATR records cannot be edited.', {
                variant: 'warning'
            });
            return;
        }

        this.setState({
            addDialogOpen: true,
            addDialogMode: 'edit',
            selectedRow: row,
            addingRowData: {
                ...row,
                ...this.getPayload(row)
            }
        })
    }

    handleUpdateRecord = () => {
        const rowId = this.state.selectedRow?.id || this.state.selectedRow?.pk;
        const payload = this.getAddPayload();

        if (!rowId || !this.state.selectedRow) {
            this.props.enqueueSnackbar('Unable to identify row for update.', {
                variant: 'warning'
            });
            return;
        }
        if (!this.validatePayload(payload)) {
            return;
        }

        const { updated_by, date_opened, ...selectedRowWithoutExcludedFields } = this.state.selectedRow;

        this.setState({ tableLoading: true })
        Service.patch(`/api/atr/records/update_atr_records/?atr_id=${rowId}`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                ...selectedRowWithoutExcludedFields,
                ...payload,
                id: rowId,
            },
        })
            .then(() => {
                this.props.enqueueSnackbar('Updated successfully.', {
                    variant: 'success'
                });
                this.setState({
                    addDialogOpen: false,
                    addDialogMode: 'add',
                    selectedRow: null,
                    addingRowData: {}
                }, this.getData)
            })
            .catch(error => {
                console.log(error)
                this.setState({ tableLoading: false })
                if (error.status === 400) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar(this.getApiErrorMessage(error), {
                        variant: 'error'
                    });
                }
            });
    }

    handleDeleteRow = (row) => {
        const rowId = row?.id || row?.pk;

        if (!rowId) {
            this.props.enqueueSnackbar('Unable to identify row for delete.', {
                variant: 'warning'
            });
            return;
        }

        this.setState({ tableLoading: true })
        Service.delete(`/api/atr/records/${rowId}/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(() => {
                this.props.enqueueSnackbar('Deleted successfully.', {
                    variant: 'success'
                });
                this.getData()
            })
            .catch(error => {
                console.log(error)
                this.setState({ tableLoading: false })
                this.props.enqueueSnackbar(this.getApiErrorMessage(error), {
                    variant: 'error'
                });
            });
    }

    handleOpenAddDialog = () => {
        this.setState({
            addDialogOpen: true,
            addDialogMode: 'add',
            selectedRow: null,
            addingRowData: this.getPayload({})
        })
    }

    handleCloseAddDialog = () => {
        this.setState({
            addDialogOpen: false,
            addDialogMode: 'add',
            selectedRow: null,
            addingRowData: {}
        })
    }

    handleAddFieldChange = (field, value) => {
        const lookupNameFields = {
            division: 'division_name',
            region: 'owner_region_name',
            payrole_process: 'payrole_process_name',
            role: 'role_name',
            discipline: 'discipline_name',
            crm: 'crm_name',
        };
        const nameField = lookupNameFields[field];

        this.setState(prevState => ({
            addingRowData: {
                ...prevState.addingRowData,
                [field]: value,
                ...(nameField ? { [nameField]: this.getLookupOptionLabel(value) } : {})
            }
        }))
    }

    handleSearchChange = (event) => {
        this.setState({ searchQuery: event.target.value })
    }

    handleFilterChange = (event) => {
        const { id, name, value } = event.target;
        const field = name || id;

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [field]: value
            }
        }))
    }

    handleColumnFilterFieldChange = (event, selectedColumn) => {
        this.setState({
            columnFilterField: selectedColumn?.field || null,
            columnFilterValue: ''
        })
    }

    handleColumnFilterValueChange = (value) => {
        this.setState({ columnFilterValue: value || '' })
    }

    getSelectedColumnFilter() {
        return this.state.columns.find((column) => column.field === this.state.columnFilterField) || null;
    }

    getDropdownFilterFields() {
        return ['division_name', 'discipline_name', 'payrole_process_name', 'crm_name', 'owner_region_name', 'role_name', 'role_groups', 'status'];
    }

    isDropdownFilterField(field) {
        return this.getDropdownFilterFields().includes(field);
    }

    isSearchableDropdownFilterField(field) {
        return ['crm_name', 'role_name', 'role_groups'].includes(field);
    }

    handleDropdownFilterSearchChange = (field, event) => {
        const value = event.target.value;

        this.setState(prevState => ({
            dropdownFilterSearches: {
                ...prevState.dropdownFilterSearches,
                [field]: value
            }
        }))
    }

    isDateFilterField(field) {
        return field === 'date_opened';
    }

    getColumnFilterOptions(field) {
        if (!field) {
            return [];
        }

        if (field === 'status') {
            return atrStatusOptions.map((option) => option.name);
        }

        const lookupConfig = this.getLookupConfig(field);
        if (lookupConfig?.options?.length) {
            return [...new Set(lookupConfig.options.map((option) => this.getLookupOptionLabel(option).trim()).filter(Boolean))].sort((a, b) => a.localeCompare(b));
        }

        const column = this.state.columns.find((item) => item.field === field);

        return [...new Set(this.state.data.map((row) => this.getTableCellText(row, column || { field }).trim()).filter(Boolean))].sort((a, b) => a.localeCompare(b));
    }

    getFilters(column) {
        if (this.isDateFilterField(column.field)) {
            return <MuiPickersUtilsProvider utils={DateFnsUtils} >
                <KeyboardDatePicker
                    autoOk
                    clearable
                    format="dd-MM-yyyy"
                    margin="dense"
                    id={column.field}
                    value={this.getDatePickerValue(this.state.filters[column.field])}
                    disabled={this.state.tableLoading}
                    onChange={(date) => this.handleFieldChange(column.field, date)}
                    KeyboardButtonProps={{
                        'aria-label': 'filter date opened',
                    }}
                    style={{ width: 120, margin: 0 }}
                    InputProps={{ style: { fontSize: 12, height: 28 } }}
                />
            </MuiPickersUtilsProvider>
        }

        if (this.isDropdownFilterField(column.field)) {
            const options = this.getColumnFilterOptions(column.field);
            const selectedValues = Array.isArray(this.state.filters[column.field]) ? this.state.filters[column.field] : [];
            const searchValue = this.state.dropdownFilterSearches[column.field] || '';
            const filteredOptions = this.isSearchableDropdownFilterField(column.field) && searchValue.trim()
                ? options.filter((option) => option.toLowerCase().includes(searchValue.trim().toLowerCase()))
                : options;

            return <Select
                size='small'
                multiple
                autoWidth
                name={column.field}
                id={column.field}
                value={selectedValues}
                disabled={this.state.tableLoading}
                onChange={this.handleFilterChange}
                variant="standard"
                displayEmpty
                style={{ minWidth: 72, maxWidth: 108, fontSize: 12 }}
                MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
                renderValue={(selected) => selected.length > 0 ? <Box fontSize="12px">{selected.join(', ')}</Box> : <em></em>}
            >
                {this.isSearchableDropdownFilterField(column.field) ?
                    <ListSubheader style={{ backgroundColor: '#ffffff', padding: '8px 12px', position: 'sticky', top: 0, zIndex: 2 }}>
                        <TextField
                            autoFocus
                            placeholder={`Search ${column.title}`}
                            value={searchValue}
                            onChange={(event) => this.handleDropdownFilterSearchChange(column.field, event)}
                            onClick={(event) => event.stopPropagation()}
                            onKeyDown={(event) => event.stopPropagation()}
                            fullWidth
                            size='small'
                        />
                    </ListSubheader>
                    : null}
                {filteredOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                        <Checkbox size='small' checked={selectedValues.includes(option)} />
                        <ListItemText primary={option} />
                    </MenuItem>
                ))}
            </Select>
        }

        return <TextField
            size='small'
            id={column.field}
            value={this.state.filters[column.field] || ''}
            disabled={this.state.tableLoading}
            onChange={this.handleFilterChange}
            margin="dense"
            style={{ width: 99 }}
            InputProps={{
                style: { fontSize: 12, height: 28 },
                startAdornment: (
                    <InputAdornment position="start">
                        <FilterListIcon fontSize='small' />
                    </InputAdornment>
                ),
            }}
            variant="standard"
        />
    }

    getSearchableText(value) {
        if (value === null || value === undefined) {
            return '';
        }
        if (typeof value === 'object') {
            return Object.values(value).map((nestedValue) => this.getSearchableText(nestedValue)).join(' ');
        }
        return String(value);
    }

    getFilteredData() {
        const searchQuery = this.state.searchQuery.trim().toLowerCase();
        const filters = this.state.filters || {};

        return this.state.data.filter((row) => {
            const matchesSearch = !searchQuery || this.state.columns.some((column) => (
                this.getTableCellText(row, column).toLowerCase().includes(searchQuery)
            ));
            const matchesColumnFilters = this.state.columns.every((column) => {
                const filterValue = filters[column.field];

                if (this.isDateFilterField(column.field)) {
                    const normalizedFilterDate = this.formatDateToYMD(filterValue);
                    if (!normalizedFilterDate) {
                        return true;
                    }

                    return this.formatDateToYMD(row[column.field]) === normalizedFilterDate;
                }

                if (Array.isArray(filterValue)) {
                    if (filterValue.length === 0) {
                        return true;
                    }

                    if (column.field === 'role_groups') {
                        const roleGroupNames = this.getRoleGroupNames(row.role_groups).map((roleGroup) => roleGroup.toLowerCase());
                        return filterValue.some((value) => roleGroupNames.includes(this.getSearchableText(value).trim().toLowerCase()));
                    }

                    const cellValue = this.getTableCellText(row, column).trim().toLowerCase();
                    return filterValue.some((value) => cellValue === this.getSearchableText(value).trim().toLowerCase());
                }

                const normalizedFilterValue = this.getSearchableText(filterValue).trim().toLowerCase();

                if (!normalizedFilterValue) {
                    return true;
                }

                const cellValue = this.getTableCellText(row, column).trim().toLowerCase();
                return cellValue.includes(normalizedFilterValue);
            });

            return matchesSearch && matchesColumnFilters;
        });
    }

    exportToExcel = (rows) => {
        const exportData = rows.map((row) => this.state.columns.reduce((data, column) => {
            let value = this.getLookupDisplayValue(row, column);

            if (column.field === 'last_candidate' && row.last_candidate) {
                value = `${row.last_candidate.first_name || ''} ${row.last_candidate.last_name || ''}`.trim();
            }
            if (column.field === 'last_comment' && row.last_comment) {
                value = row.last_comment.comment || '';
            }

            data[column.title] = value || '';
            return data;
        }, {}));
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'ATR Records');
        XLSX.writeFile(workbook, `ATR Records ${moment().format('DD-MM-YYYY')}.xlsx`);
    }

    handleAddRecord = () => {
        const payload = this.getAddPayload();

        if (!this.validatePayload(payload)) {
            return;
        }

        this.setState({ tableLoading: true })
        Service.post('/api/atr/records/create_atr_records/', {
            headers: {
                Authorization: 'Token ' + token,
            },
            data: payload,
        })
            .then(() => {
                this.props.enqueueSnackbar('Added successfully.', {
                    variant: 'success'
                });
                this.setState({ addDialogOpen: false, addDialogMode: 'add', selectedRow: null, addingRowData: {} }, this.getData)
            })
            .catch(error => {
                console.log(error)
                this.setState({ tableLoading: false })
                if (error.status === 400) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar(this.getApiErrorMessage(error), {
                        variant: 'error'
                    });
                }
            });
    }

    getLookup() {
        this.setState({ filtersDisabled: true })
        Service.get('/api/past/employee/history/lookup_data/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    lookupData: res.data,
                    filtersDisabled: false
                })

            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    getCrm() {
        this.setState({ filtersDisabled: true })
        Service.get('/api/crm/list_live_crms/?is_trashed=False', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    crmData: res.data,
                })

            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }


    componentDidMount() {
        this.getLookup()
        this.getCrm()
        // api/crm/get_crm_data/?is_trashed=False?
        this.getData()
    }

    handleFieldChange = (field, value) => {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [field]: value
            }
        }))
    }

    getCandidates(row, skipAddDialog = false) {
        this.setState({
            coffeeLoading: true,
            addCandidateData: {},
            selectedData: {},
            isEdit: false,
            buttonDisabled: false
        })
        Service.get(`/api/atr/comments/get_atr_candidate_comments/?atr_id=${row.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    coffeeLoading: false
                }, () => {
                    for (let i = 0; i < res.data?.candidates?.length; i++) {
                        let element = res.data?.candidates[i];
                        element.comment = res.data.comment;
                    }
                    if (res.data?.candidates.length > 0) {
                        this.setState({
                            candidateListDialogOpen: true,
                            candidateList: res.data,
                            selectedRow: row,
                        });
                    } else if (skipAddDialog) {
                        this.setState({
                            candidateListDialogOpen: true,
                            candidateList: res.data,
                            selectedRow: row,
                            addCandidateDialogOpen: false,
                            addCandidateData: {},
                            isEdit: false,
                        });
                    } else {
                        this.setState({
                            addCandidateDialogOpen: true,
                            selectedRow: row,
                            addCandidateData: {},
                            isEdit: false,
                        });
                    }
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({ coffeeLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    handleOpenAddCandidateDialog = (row) => {
        this.getCandidates(row)
        // this.setState({
        //     addCandidateDialogOpen: true,
        //     selectedRow: row,
        // });
    }

    handleCloseAddCandidateDialog = () => {
        this.setState({
            addCandidateDialogOpen: false,
            selectedRow: null,
            addCandidateData: {},
            buttonDisabled: false,
            isEdit: false,
        });
    }

    handleCandidateListDialogOpen = (row) => {
        this.setState({
            candidateListDialogOpen: false,
            candidateList: [],
            selectedRow: null,
            addCandidateData: {},
            buttonDisabled: false,
            isEdit: false,
        });
    }

    handleCommentListDialogClose = () => {
        this.setState({
            commentListDialogOpen: false,
            selectedRow: null,
            commentList: [],
            selectedData: {},
            buttonDisabled: false,
            isEdit: false,
        });
    }

    handleOpenCommentsDialog = (row) => {
        Service.get(`/api/atr/comments/get_atr_comments/?atr_record=${row.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                if (res.data.length > 0) {
                    this.setState({
                        commentList: res.data
                    }, () => {
                        this.setState({
                            commentListDialogOpen: true,
                            selectedRow: row,
                        });
                    })
                } else {
                    this.setState({
                        selectedData: res.data,
                    }, () => {
                        this.setState({
                            commentsDialogOpen: true,
                            selectedRow: row,
                        });
                    })
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({ isLoading: false, tableLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });

    }

    handleCloseCommentsDialog = () => {
        this.setState({
            commentsDialogOpen: false,
            selectedRow: null,
            selectedData: {},
            buttonDisabled: false,
            isEdit: false
        });
    }

    editComments = () => {
        const data = this.state.selectedData;
        if (data.last_comment?.comment === undefined || data.last_comment?.comment === null || data.last_comment?.comment.trim() === '') {
            this.props.enqueueSnackbar('Comment cannot be empty!', {
                variant: 'warning'
            });
        } else {
            this.setState({ buttonDisabled: true });
            Service.patch(`/api/atr/comments/update_atr_comments/?comment_id=${data?.last_comment?.id}`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    'comment': data?.last_comment?.comment,
                    'atr_record': this.state.selectedRow.id
                }
            })
                .then(res => {
                    this.setState({ buttonDisabled: false, commentsDialogOpen: false, selectedRow: null, isEdit: false }, this.getData);
                    this.props.enqueueSnackbar('Comment updated successfully!', {
                        variant: 'success'
                    });
                })
                .catch(error => {
                    this.setState({ buttonDisabled: false, isEdit: false });
                    console.log(error)
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }

    addComments = () => {
        const data = this.state.selectedData;
        if (data.last_comment?.comment === undefined || data.last_comment?.comment === null || data.last_comment?.comment.trim() === '') {
            this.props.enqueueSnackbar('Comment cannot be empty!', {
                variant: 'warning'
            });
        } else {

            this.setState({ buttonDisabled: true });
            Service.post(`/api/atr/comments/create_atr_comments/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    'comment': data?.last_comment?.comment,
                    'atr_record': this.state.selectedRow.id
                }
            })
                .then(res => {
                    this.setState({ buttonDisabled: false, commentsDialogOpen: false, selectedRow: null, isEdit: false }, this.getData);
                    this.props.enqueueSnackbar('Comment addeed successfully!', {
                        variant: 'success'
                    });
                })
                .catch(error => {
                    this.setState({ buttonDisabled: false, isEdit: false });
                    console.log(error)
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }

    editCandidate = () => {
        if (this.state.addCandidateData?.first_name === undefined || this.state.addCandidateData?.first_name === null || this.state.addCandidateData?.first_name.trim() === '' ||
            this.state.addCandidateData?.last_name === undefined || this.state.addCandidateData?.last_name === null || this.state.addCandidateData?.last_name.trim() === '' ||
            this.state.addCandidateData?.email === undefined || this.state.addCandidateData?.email === null || this.state.addCandidateData?.email.trim() === '' ||
            this.state.addCandidateData?.start_date === undefined || this.state.addCandidateData?.start_date === null) {
            this.props.enqueueSnackbar('All fields are required!', {
                variant: 'warning'
            });
            return;
        } else {
            this.setState({ buttonDisabled: true });
            const data = this.state.addCandidateData;
            Service.patch(`/api/atr/candidates/update_atr_candidate/?candidate_id=${this.state.addCandidateData?.candidate_id}`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    'first_name': data?.first_name,
                    'last_name': data?.last_name,
                    'email': data?.email || '',
                    'start_date': moment(data?.start_date).format('YYYY-MM-DD'),
                    'status': liveCandidateStatusId,
                    'atr_record': this.state.selectedRow?.id
                }
            })
                .then(res => {
                    this.setState({ buttonDisabled: false, commentsDialogOpen: false, selectedRow: null, addCandidateDialogOpen: false, addCandidateData: {}, isEdit: false }, this.getData);
                    this.props.enqueueSnackbar('Candidate added successfully!', {
                        variant: 'success'
                    });
                })
                .catch(error => {
                    this.setState({ buttonDisabled: false, isEdit: false });
                    console.log(error)
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }


    addCandidate = () => {

        if (this.state.addCandidateData?.first_name === undefined || this.state.addCandidateData?.first_name === null || this.state.addCandidateData?.first_name.trim() === '' ||
            this.state.addCandidateData?.last_name === undefined || this.state.addCandidateData?.last_name === null || this.state.addCandidateData?.last_name.trim() === '' ||
            this.state.addCandidateData?.email === undefined || this.state.addCandidateData?.email === null || this.state.addCandidateData?.email.trim() === '' ||
            this.state.addCandidateData?.start_date === undefined || this.state.addCandidateData?.start_date === null) {
            this.props.enqueueSnackbar('All fields are required!', {
                variant: 'warning'
            });
            return;
        } else {
            this.setState({ buttonDisabled: true });
            const data = this.state.addCandidateData;
            Service.post(`/api/atr/candidates/create_atr_candidate/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    'first_name': data?.first_name,
                    'last_name': data?.last_name,
                    'email': data?.email || '',
                    'start_date': moment(data?.start_date).format('YYYY-MM-DD'),
                    'status': liveCandidateStatusId,
                    'atr_record': this.state.selectedRow?.id
                }
            })
                .then(res => {
                    this.setState({ buttonDisabled: false, commentsDialogOpen: false, selectedRow: null, addCandidateDialogOpen: false, addCandidateData: {} }, this.getData);
                    this.props.enqueueSnackbar('Candidate added successfully!', {
                        variant: 'success'
                    });
                })
                .catch(error => {
                    this.setState({ buttonDisabled: false });
                    console.log(error)
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }

    handleNewCandidateAdd = () => {
        this.setState({
            addCandidateDialogOpen: true,
            candidateListDialogOpen: false,
            selectedRow: this.state.selectedRow,
            addCandidateData: {},
            buttonDisabled: false,
            isEdit: false,
        });
    }

    handleNewCommentAdd = () => {
        this.setState({
            commentsDialogOpen: true,
            commentListDialogOpen: false,
            selectedRow: this.state.selectedRow,
            selectedData: {},
            isEdit: false,
        });
    }

    archiveCandidate = (candidate) => {
        this.setState({
            coffeeLoading: true
        })
        Service.patch(`/api/atr/candidates/update_atr_candidate/?candidate_id=${candidate?.candidate_id}`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                'first_name': candidate?.first_name,
                'last_name': candidate?.last_name,
                'email': candidate?.email || '',
                'start_date': moment(candidate?.start_date).format('YYYY-MM-DD'),
                'status': 1,
                'atr_record': this.state.selectedRow?.id
            }
        })
            .then(res => {
                // this.setState({ buttonDisabled: false, commentsDialogOpen: false, selectedRow: null, addCandidateDialogOpen: false, addCandidateData: {} });
                this.getCandidates(this.state.selectedRow, true);
                this.props.enqueueSnackbar('Candidate archived successfully!', {
                    variant: 'success'
                });
            })
            .catch(error => {
                this.setState({ buttonDisabled: false, coffeeLoading: false });
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    handleEditComment = (comment) => {
        this.setState({
            selectedData: {
                ...this.state.selectedData,
                last_comment: comment
            },
            isEdit: true
        }, () => {
            this.setState({
                commentsDialogOpen: true,
                commentListDialogOpen: false,
                selectedRow: this.state.selectedRow,
            });
        });
    }

    handleEditCandidate = (candidate) => {
        this.setState({
            addCandidateDialogOpen: true,
            candidateListDialogOpen: false,
            selectedRow: this.state.selectedRow,
            addCandidateData: {
                ...candidate,
            },
            isEdit: true
        });
    }

    render() {
        const filteredData = this.getFilteredData();
        const isCompletedStatusView = this.props.status === 'completed';

        return (
            <div>
                {this.state.isLoading ? <Box display='flex' justifyContent='center' alignItems='center' width='100%'>
                    <CircularProgress />
                </Box> :
                    <TableContainer component={Paper}>
                        {this.state.tableLoading && <Box display='flex' justifyContent='center' p={1}>
                            <CircularProgress size={24} />
                        </Box>}
                        <Box display='flex' justifyContent='space-between' alignItems='center' p={1}>
                            <Box marginLeft={2}><Typography variant='h6'>ATR Records</Typography></Box>
                            <Box display='flex' alignItems='center' style={{ gap: 8 }}>
                                <TextField
                                    label="Search"
                                    variant="outlined"
                                    size="small"
                                    value={this.state.searchQuery}
                                    onChange={this.handleSearchChange}
                                    disabled={this.state.tableLoading}
                                />
                                {!isCompletedStatusView ?
                                    <Button size='small' color='primary' variant='contained' onClick={this.handleOpenAddDialog} disabled={this.state.tableLoading}>Add</Button>
                                    : null}
                                <Button
                                    color='primary'
                                    variant='outlined'
                                    size='small'
                                    onClick={() => this.exportToExcel(filteredData)}
                                    disabled={this.state.tableLoading || filteredData.length === 0}
                                    startIcon={<GetAppIcon fontSize='small' />}
                                >
                                    Export Excel
                                </Button>
                            </Box>
                        </Box>
                        <Table sx={{ minWidth: 650 }} size="small" >
                            <TableHead>
                                <TableRow>
                                    {this.state.columns.map((column) => (
                                        <TableCell key={column.field} align='center' style={compactTableCellStyle}>{column.title}</TableCell>
                                    ))}
                                    <TableCell key="actions" align='center' style={compactTableCellStyle}>Actions</TableCell>
                                </TableRow>
                                <TableRow>
                                    {this.state.columns.map((column) => (
                                        <TableCell key={`${column.field}-filter`} align='center' style={compactFilterCellStyle}>{this.getFilters(column)}</TableCell>
                                    ))}
                                    <TableCell key="actions-filter" align='center' style={compactFilterCellStyle} />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row, index) => {
                                    const rowId = this.getRowId(row, index);
                                    const isCompletedAtrRecord = this.isCompletedAtrStatus(row?.status);

                                    return <TableRow key={rowId} >
                                        {this.state.columns.map((column) => {
                                            return <TableCell key={column.field} align='center' style={compactTableCellStyle}>
                                                {column.field === 'role_groups' ?
                                                    <Box display='flex' flexWrap='wrap' justifyContent='center' style={{ gap: 4 }}>
                                                        {this.getRoleGroupNames(row.role_groups).length > 0
                                                            ? this.getRoleGroupNames(row.role_groups).map((roleGroup, roleGroupIndex) => (
                                                                <Chip key={`${roleGroup}-${roleGroupIndex}`} label={roleGroup} size='small' />
                                                            ))
                                                            : <Typography variant='body2'>-</Typography>}
                                                    </Box> :
                                                typeof row[column.field] === 'object' && column.field === 'last_candidate' ?
                                                    <Box display='flex' flexDirection='column' alignItems='flex-start' style={{ gap: 6 }}>
                                                        <Typography variant='body2' align='left'><b>Name:</b> {`${row[column.field]?.first_name || ''} ${row[column.field]?.last_name || ''}`.trim() || '-'}</Typography>
                                                        <Typography variant='body2' align='left'><b>Start Date:</b> {row[column.field]?.start_date && moment(row[column.field]?.start_date).isValid() ? moment(row[column.field]?.start_date).format('DD-MM-YYYY') : '-'}</Typography>
                                                    </Box> :
                                                    typeof row[column.field] === 'object' && column.field === 'last_comment' ?
                                                        <Box display='flex' flexDirection='column' alignItems='flex-start' style={{ gap: 6 }}>
                                                            <Typography variant='body2' align='left'><b>Comment:</b> {row[column.field]?.comment?.trim() || '-'}</Typography>
                                                            <Typography variant='body2' align='left'><b>Created by:</b> {row[column.field]?.created_by || '-'}</Typography>
                                                        </Box>
                                                        : this.getLookupDisplayValue(row, column)}
                                            </TableCell>
                                        })}
                                        <TableCell align='center' style={compactTableCellStyle}>
                                            <Tooltip title={isCompletedAtrRecord ? 'Completed ATR records cannot be edited' : 'Edit'}>
                                                <IconButton size="small" onClick={() => this.handleOpenEditDialog(row)} disabled={this.state.tableLoading || isCompletedAtrRecord}>
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete">
                                                <IconButton size="small" onClick={() => this.handleDeleteRow(row)} disabled={this.state.tableLoading}>
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Comments">
                                                <IconButton size="small" onClick={() => this.handleOpenCommentsDialog(row)} disabled={this.state.tableLoading}>
                                                    <CommentIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Add Candidate">
                                                <IconButton size="small" onClick={() => this.handleOpenAddCandidateDialog(row)} disabled={this.state.tableLoading}>
                                                    <PersonAddIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                })}
                            </TableBody>
                        </Table>
                        <Dialog
                            open={this.state.addDialogOpen}
                            onClose={this.handleCloseAddDialog}
                            maxWidth="sm"
                            fullWidth
                            PaperProps={{ style: dialogPaperStyle }}
                        >
                            <DialogTitle style={dialogTitleStyle}>
                                <Typography variant='h6' style={{ fontWeight: 600 }}>
                                    {this.state.addDialogMode === 'edit' ? 'Edit ATR Record' : 'Add ATR Record'}
                                </Typography>
                            </DialogTitle>
                            <DialogContent style={dialogContentStyle}>
                                <Box display='flex' flexDirection='column' style={{ gap: 10 }}>
                                    <Box marginTop={1}>
                                        <TextField
                                            key="owner"
                                            label="Owner"
                                            variant="outlined"
                                            size="small"
                                            required
                                            value={this.state.addingRowData['owner'] || ''}
                                            sx={{ width: '100%' }}
                                            onChange={(event) => this.handleAddFieldChange('owner', event.target.value)}
                                            fullWidth
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <TextField
                                            key="bbuk_number"
                                            label="BBUK Number"
                                            variant="outlined"
                                            size="small"
                                            required
                                            value={this.state.addingRowData['bbuk_number'] || ''}
                                            sx={{ width: '100%' }}
                                            onChange={(event) => this.handleAddFieldChange('bbuk_number', event.target.value)}
                                            fullWidth
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <KeyboardDatePicker
                                                autoOk
                                                clearable
                                                animateYearScrolling
                                                format="dd-MM-yyyy"
                                                margin="normal"
                                                id="date_opened"
                                                label="Date Opened"
                                                required
                                                value={this.getDatePickerValue(this.state.addingRowData['date_opened'])}
                                                onChange={(date) => this.handleAddFieldChange('date_opened', date)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                fullWidth
                                                renderInput={(params) => <TextField {...params} variant="outlined" required fullWidth />}
                                                style={{ margin: 0 }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Box>
                                    <Box marginTop={1}>
                                        <Autocomplete
                                            options={this.state.lookupData.market_subvertical || []}
                                            getOptionLabel={(option) => option?.name || option?.label || ''}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            value={this.getAutocompleteValue('division', this.state.lookupData.market_subvertical || [])}
                                            onChange={(event, newValue) => this.handleAddFieldChange('division', newValue)}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} label="Division" variant="outlined" size="small" required fullWidth />}
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <Autocomplete
                                            options={this.state.lookupData.owner_region_sector || []}
                                            getOptionLabel={(option) => option?.name || option?.label || ''}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            value={this.getAutocompleteValue('owner_region', this.state.lookupData.owner_region_sector || [])}
                                            onChange={(event, newValue) => this.handleAddFieldChange('owner_region', newValue)}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} label="Region" variant="outlined" size="small" required fullWidth />}
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <Autocomplete
                                            options={this.state.lookupData.payrole_process || []}
                                            getOptionLabel={(option) => option?.name || option?.label || ''}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            value={this.getAutocompleteValue('payrole_process', this.state.lookupData.payrole_process || [])}
                                            onChange={(event, newValue) => this.handleAddFieldChange('payrole_process', newValue)}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} label="Payrole Process" variant="outlined" size="small" required fullWidth />}
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <Autocomplete
                                            options={this.state.lookupData.job_title || []}
                                            getOptionLabel={(option) => option?.name || option?.label || ''}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            value={this.getAutocompleteValue('role', this.state.lookupData.job_title || [])}
                                            onChange={(event, newValue) => this.handleAddFieldChange('role', newValue)}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} label="Role" variant="outlined" size="small" required fullWidth />}
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <Autocomplete
                                            options={this.state.lookupData.subsector || []}
                                            getOptionLabel={(option) => option?.name || option?.label || ''}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            value={this.getAutocompleteValue('discipline', this.state.lookupData.subsector || [])}
                                            onChange={(event, newValue) => this.handleAddFieldChange('discipline', newValue)}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} label="Discipline" variant="outlined" size="small" required fullWidth />}
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <Autocomplete
                                            options={this.state.crmData || []}
                                            getOptionLabel={(option) => option?.name || option?.label || ''}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            value={this.getAutocompleteValue('crm', this.state.crmData || [])}
                                            onChange={(event, newValue) => this.handleAddFieldChange('crm', newValue)}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} label="CRM" variant="outlined" size="small" fullWidth />}
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <TextField
                                            select
                                            key="status"
                                            label="Status"
                                            variant="outlined"
                                            size="small"
                                            required
                                            value={this.state.addingRowData['status'] ?? ''}
                                            sx={{ width: '100%' }}
                                            onChange={(event) => this.handleAddFieldChange('status', event.target.value)}
                                            fullWidth
                                        >
                                            {atrFormStatusOptions.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Box>
                                </Box>
                            </DialogContent>
                            <DialogActions style={dialogActionsStyle}>
                                <Button variant='contained' color='secondary' size='small' onClick={this.handleCloseAddDialog} disabled={this.state.tableLoading}>Cancel</Button>
                                <Button
                                    variant='contained'
                                    size='small'
                                    onClick={this.state.addDialogMode === 'edit' ? this.handleUpdateRecord : this.handleAddRecord}
                                    disabled={this.state.tableLoading}
                                    color='primary'
                                >
                                    {this.state.addDialogMode === 'edit' ? 'Update' : 'Add'}
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={this.state.commentsDialogOpen}
                            onClose={this.handleCloseCommentsDialog}
                            maxWidth="sm"
                            fullWidth
                            PaperProps={{ style: dialogPaperStyle }}
                        >
                            <DialogTitle style={dialogTitleStyle}>
                                <Typography variant='h6' style={{ fontWeight: 600 }}>
                                    Comments for {this.state.selectedRow?.owner || ''}
                                </Typography>
                            </DialogTitle>
                            <DialogContent style={{ ...dialogContentStyle, paddingBottom: '10px' }}>
                                <Box display='flex' flexDirection='column'>
                                    {/* <Box marginTop={1} style={{ backgroundColor: '#f9fbfd', border: '1px solid #e7edf4', borderRadius: '8px', padding: '10px 12px' }}>
                                        <Typography variant='subtitle2' style={{ color: '#5b6678', fontWeight: 600, marginBottom: '4px' }}>Candidate Name</Typography>
                                        <Box style={{ color: '#17212f', fontWeight: 500 }}>{this.state.selectedData?.first_name + ' ' + this.state.selectedData?.last_name}</Box>
                                    </Box> */}
                                    <Box margin={1}>
                                        <Typography variant='subtitle2' style={{ color: '#5b6678', fontWeight: 600, marginBottom: '6px' }}>Comments</Typography>
                                        <TextField
                                            value={this.state.selectedData?.last_comment?.comment || ''}
                                            onChange={(e) => this.setState({ selectedData: { ...this.state.selectedData, last_comment: { ...this.state.selectedData.last_comment, comment: e.target.value } } })}
                                            fullWidth
                                            multiline
                                            rows={4}
                                            variant='outlined'
                                            InputProps={{
                                                style: {
                                                    borderRadius: '8px',
                                                    backgroundColor: '#ffffff'
                                                }
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </DialogContent>
                            <DialogActions style={dialogActionsStyle}>
                                <Button variant='contained' color='secondary' size='small' onClick={this.handleCloseCommentsDialog}>Close</Button>
                                <Button disabled={this.state.buttonDisabled} variant='contained' color='primary' size='small' onClick={this.state.isEdit ? this.editComments : this.addComments}>{this.state.isEdit ? 'Edit' : 'Add'}</Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog open={this.state.addCandidateDialogOpen} onClose={this.handleCloseAddCandidateDialog} maxWidth="sm" fullWidth PaperProps={{ style: dialogPaperStyle }}>
                            <DialogTitle style={dialogTitleStyle}>
                                <Typography variant='h6' style={{ fontWeight: 600 }}>
                                    {this.state.isEdit ? 'Edit' : 'Add'} Candidate for {this.state.selectedRow?.owner || ''}
                                </Typography>
                            </DialogTitle>
                            <DialogContent style={dialogContentStyle}>
                                <Box display='flex' flexDirection='column' style={{ gap: 10 }}>
                                    <Box marginTop={1}>
                                        <TextField
                                            label="First Name"
                                            variant="outlined"
                                            size="small"
                                            value={this.state.addCandidateData?.first_name || ''}
                                            onChange={(event) => this.setState({ addCandidateData: { ...this.state.addCandidateData, first_name: event.target.value } })}
                                            fullWidth
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <TextField
                                            label="Last Name"
                                            variant="outlined"
                                            size="small"
                                            value={this.state.addCandidateData?.last_name || ''}
                                            onChange={(event) => this.setState({ addCandidateData: { ...this.state.addCandidateData, last_name: event.target.value } })}
                                            fullWidth
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <TextField
                                            label="Email"
                                            variant="outlined"
                                            size="small"
                                            value={this.state.addCandidateData?.email || ''}
                                            onChange={(event) => this.setState({ addCandidateData: { ...this.state.addCandidateData, email: event.target.value } })}
                                            fullWidth
                                        />
                                    </Box>
                                    <Box marginTop={1}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <KeyboardDatePicker
                                                autoOk
                                                clearable
                                                animateYearScrolling
                                                format="dd/MM/yyyy"
                                                margin="normal"
                                                id="start_date"
                                                label="Start Date"
                                                value={this.state.addCandidateData?.start_date || null}
                                                onChange={(date) => {
                                                    let addCandidateData = this.state.addCandidateData
                                                    addCandidateData['start_date'] = date
                                                    this.setState({ addCandidateData })
                                                }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                fullWidth
                                                renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                                                style={{ margin: 0 }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Box>
                                </Box>
                            </DialogContent>
                            <DialogActions style={dialogActionsStyle}>
                                <Button variant='contained' color='secondary' size='small' onClick={this.handleCloseAddCandidateDialog}>Cancel</Button>
                                <Button disabled={this.state.buttonDisabled} variant='contained' color='primary' size='small' onClick={this.state.isEdit ? this.editCandidate : this.addCandidate}>{this.state.isEdit ? 'Edit' : 'Add'}</Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog maxWidth="md" fullWidth open={this.state.candidateListDialogOpen} onClose={this.handleCandidateListDialogClose} PaperProps={{ style: dialogPaperStyle }}>
                            <DialogTitle style={dialogTitleStyle}>
                                <Box display='flex' alignItems='center' justifyContent='space-between' width='100%' margin={1}>
                                    <Typography variant='h6' style={{ fontWeight: 600 }}>Candidate List</Typography>
                                    <Tooltip title="Add New Candidate">
                                        <IconButton size="small" onClick={this.handleNewCandidateAdd} >
                                            <PersonAddIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </DialogTitle>
                            <DialogContent style={{ ...dialogContentStyle, paddingBottom: 18 }}>
                                <Box display='flex' flexDirection='column' style={{ gap: 12 }}>
                                    {(this.state.candidateList?.candidates || []).length === 0 ?
                                        <Box
                                            style={{
                                                padding: '14px 16px',
                                                border: '1px solid #e2e8f0',
                                                borderRadius: 8,
                                                backgroundColor: '#f9fbfd'
                                            }}
                                        >
                                            <Typography variant='body2' style={{ color: '#5b6678' }}>
                                                There are no candidates to show.
                                            </Typography>
                                        </Box>
                                        : (this.state.candidateList?.candidates || []).map((candidate, index) => (
                                            <Box
                                                key={candidate?.id || index}
                                                display='flex'
                                                alignItems='center'
                                                justifyContent='space-between'
                                                style={{
                                                    gap: 16,
                                                    padding: '14px 16px',
                                                    border: '1px solid #e2e8f0',
                                                    borderRadius: 8,
                                                    backgroundColor: '#f9fbfd'
                                                }}
                                            >
                                                <Box display='flex' flexDirection='column' style={{ gap: 6, minWidth: 0 }}>
                                                    <Typography variant='subtitle1' style={{ fontWeight: 600, color: '#17212f' }}>
                                                        Name: {candidate?.first_name || '-'} {candidate?.last_name || ''}
                                                    </Typography>
                                                    <Typography variant='body2' style={{ color: '#5b6678', whiteSpace: 'pre-wrap' }}>
                                                        Comments: {candidate?.comment || candidate?.last_comment?.comment || 'No comments available'}
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <Button variant='outlined' size='small' color='primary' style={{ flexShrink: 0 }} onClick={() => { this.archiveCandidate(candidate) }}>Archive</Button>
                                                    <IconButton size='small' onClick={() => this.handleEditCandidate(candidate)}><EditIcon fontSize='small' /></IconButton>
                                                </Box>
                                            </Box>
                                        ))}
                                </Box>
                            </DialogContent>
                            <DialogActions style={dialogActionsStyle}>
                                <Button variant='contained' color='secondary' size='small' onClick={this.handleCandidateListDialogOpen}>Close</Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog maxWidth="md" fullWidth open={this.state.commentListDialogOpen} onClose={this.handleCommentListDialogClose} PaperProps={{ style: dialogPaperStyle }}>
                            <DialogTitle style={dialogTitleStyle}>
                                <Box display='flex' alignItems='center' justifyContent='space-between' width='100%' margin={1}>
                                    <Typography variant='h6' style={{ fontWeight: 600 }}>Comment List</Typography>
                                    <Tooltip title="Add New Comment">
                                        <IconButton size="small" onClick={this.handleNewCommentAdd} >
                                            <PostAddIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </DialogTitle>
                            <DialogContent style={{ ...dialogContentStyle, paddingBottom: 18 }}>
                                <Box display='flex' flexDirection='column' style={{ gap: 12 }}>
                                    {(this.state.commentList || []).map((comment, index) => (
                                        <Box
                                            key={comment?.id || index}
                                            display='flex'
                                            alignItems='center'
                                            justifyContent='space-between'
                                            style={{
                                                gap: 16,
                                                padding: '14px 16px',
                                                border: '1px solid #e2e8f0',
                                                borderRadius: 8,
                                                backgroundColor: '#f9fbfd'
                                            }}
                                        >
                                            <Box display='flex' flexDirection='column' style={{ gap: 6, minWidth: 0 }}>
                                                <Typography variant='subtitle1' style={{ fontWeight: 600, color: '#17212f' }}>
                                                    Comments: {comment?.comment || 'No comments available'}
                                                </Typography>
                                                <Typography variant='body2' style={{ color: '#5b6678', whiteSpace: 'pre-wrap' }}>
                                                    Date Created: {moment(comment?.date_created).format('DD-MM-YYYY') || '-'}
                                                </Typography>
                                            </Box>
                                            <IconButton size='small' onClick={() => this.handleEditComment(comment)}><EditIcon fontSize='small' /></IconButton>
                                            {/* <Button variant='outlined' size='small' color='primary' style={{ flexShrink: 0 }} onClick={() => { this.archiveCandidate() }}>Archive</Button> */}
                                        </Box>
                                    ))}
                                </Box>
                            </DialogContent>
                            <DialogActions style={dialogActionsStyle}>
                                <Button variant='contained' color='secondary' size='small' onClick={this.handleCommentListDialogClose}>Close</Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog maxWidth="sm" open={this.state.coffeeLoading} aria-labelledby="form-dialog-title">
                            <Box m={3} p={3}>
                                <CoffeeLoading color={getPrimaryColor()} size='small' />
                            </Box>
                        </Dialog>
                    </TableContainer>
                }
            </div>
        )
    }
}

export default withSnackbar(Atr);
